import { getCurrency } from '../../../../cache';
export function getCalculatedExchangePrices(prices) {
    var _a, _b, _c, _d;
    if (!prices) {
        return { total: null, charge: null, ticket: null };
    }
    const currency = ((_a = prices.priceToPay) === null || _a === void 0 ? void 0 : _a.currency) || getCurrency();
    const agencyChargesForExareAmount = ((_b = prices === null || prices === void 0 ? void 0 : prices.agencyChargesForExare) === null || _b === void 0 ? void 0 : _b.amount) || 0;
    const exchangeAirlinePenaltyAmount = ((_c = prices === null || prices === void 0 ? void 0 : prices.exchangeAirlinePenalty) === null || _c === void 0 ? void 0 : _c.amount) || 0;
    const totalAmount = ((_d = prices.priceToPay) === null || _d === void 0 ? void 0 : _d.amount) || 0;
    const chargeAmount = agencyChargesForExareAmount + exchangeAirlinePenaltyAmount;
    const ticketAmount = totalAmount - chargeAmount;
    return {
        total: { currency, amount: totalAmount },
        charge: { currency, amount: chargeAmount },
        ticket: { currency, amount: ticketAmount }
    };
}
